import ApiConnector from "@/repository/connector";

class Analytics {
  get = async ({ id }) => {
    const result = {
      value: null,
      error: null,
    }
    const response = await ApiConnector.connector.get(`/api/supervisions/analytics/${id}/`);
    result.value = response.data;
    result.error = response.detail
    return result;
  };
  addComment = async ({ id, payload }) => {
    const result = {
      value: null,
      error: null,
    }
    const response = await ApiConnector.connectorFormData.post(`/api/supervisions/analytics/${id}/comment/`, payload);
    result.value = response.data;
    result.error = response.detail
    return result;
  };
  setVerified = async ({ id }) => {
    const result = {
      value: null,
      error: null,
    }
    const response = await ApiConnector.connector.post(`/api/supervisions/analytics/${id}/verify/`);
    result.value = response.data;
    result.error = response.detail
    return result;
  };
  resetVerified = async ({ id }) => {
    const result = {
      value: null,
      error: null,
    }
    const response = await ApiConnector.connector.post(`/api/supervisions/analytics/${id}/clear-verification/`);
    result.value = response.data;
    result.error = response.detail
    return result;
  };
  update = async ({ id, payload }) => {
    const result = {
      value: null,
      error: null,
    }
    const response = await ApiConnector.connector.patch(`/api/supervisions/analytics/${id}/`, payload);
    result.value = response.data;
    result.error = response.detail
    return result;
  };
}

export default new Analytics()